import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
// ELIMINADO: import { Helmet } from "react-helmet"; - Ya no se usa, manejamos SEO con DOM directo
import logoImage from "../../../assets/images/logo.png";
import callApi from "../../../services/callApi";
import FloatingAgendarButton from "./components/BotonAgendar";
import SeccionPerfil from "./components/SeccionPerfil";
import SeccionSobreMi from "./components/SeccionSobreMi";
import SeccionServicios from "./components/SeccionServicios";
import SeccionContenido from "./components/SeccionContenido";
import SeccionEvaluaciones from "./components/SeccionEvaluaciones";
import SEOProfesionalInjector from "./components/SEOProfesionalInjector"; // Componente para SEO dinámico (meta tags + JSON-LD)
import SeccionEspecialidades from "./components/SeccionEspecialidades"; // NUEVO
import SeccionContacto from "./components/SeccionContacto"; // NUEVO
import SeccionEventos from "./components/SeccionEventos"; // NUEVO
import SkeletonPerfilCompleto from "./components/SkeletonPerfilCompleto"; // Skeleton unificado de loading

// ==============================================
// COMPONENTE PRINCIPAL
// ==============================================

function Profesionales() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const MySwal = withReactContent(Swal);
  const [isLoading, setIsLoading] = useState(true);
  const [profesionalInfo, setProfesionalInfo] = useState(null);
  const [isImageLoading, setIsImageLoading] = useState(true);
  const [contentImageLoadingStates, setContentImageLoadingStates] = useState({});
  const navigate = useNavigate();
  const [showButton, setShowButton] = useState(true);
  const [expandedService, setExpandedService] = useState(null);
  const agendarSectionRef = useRef(null);
  const serviceCardsRef = useRef(null);
  
  // Estado para la paginación de evaluaciones
  const [currentPage, setCurrentPage] = useState(1);

  const location = useLocation();
  const professionalLink = location.pathname.split("/pro/")[1]; // Obtiene todo lo que viene después de /pro/

  // NUEVO: Tracking específico para pacientes viendo perfiles
  useEffect(() => {
    if (window.fbq) {
      window.fbq('trackCustom', 'PageViewCliente', {
        content_name: professionalLink, // Opcional: para saber qué perfil vieron
        content_category: 'Perfil Profesional'
      });
    }
  }, [professionalLink]);

  useEffect(() => {
    const handleScroll = () => {
      const position = window.pageYOffset;
      const height =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight;
      setShowButton(position < (2 / 3) * height);
    };
  
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);


  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const url = `/agenda/perfilNombre?profesional_link_plataforma=${professionalLink}`;
        const response = await callApi(url);
        setProfesionalInfo(response);
      } catch (error) {
        console.error(
          "Error al obtener la información del profesional:",
          error
        );
        MySwal.fire(
          "Error",
          "No se pudo cargar la información del profesional.",
          "error"
        );
      } finally {
        setIsLoading(false);
      }
    };

    if (professionalLink) fetchData();
  }, [professionalLink]);

  useEffect(() => {
    const handleScroll = () => {
      const position = window.pageYOffset;
      const height =
        document.documentElement.scrollHeight -
        document.documentElement.clientHeight;
      setShowButton(position < (2 / 3) * height);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleAgendarClick = (servicio) => {
    if (profesionalInfo && profesionalInfo.perfil) {
      const {
        profesional_nombre_plataforma,
        profesional_profesion,
        profesional_telefono,
      } = profesionalInfo.perfil;
  
      navigate("/pro/perfil/calendario", {
        state: {
          titulo: profesional_nombre_plataforma,
          profesion: profesional_profesion,
          celukine: profesional_telefono,
          id_kinesiologo: profesionalInfo.perfil.id_profesional_fantasma,
          id_servicios: servicio.id_servicio_fantasma,
          servicio_nombre: servicio.servicio_nombre,
          servicio_duracion: servicio.servicio_duracion,
          servicio_precios: servicio.servicio_precio,
          servicio_modalidad: servicio.servicio_modalidad,
          servicio_condiciones_descripcion:
            servicio.servicio_condiciones_descripcion,
          servicio_condiciones: servicio.servicio_condiciones,
          disponibilidad: servicio.disponibilidad,
          // Cambio aquí: usar los valores del servicio en lugar de profesionalInfo
          perfil_pago: servicio.pago,
          perfil_pago_tarjeta: servicio.pago_tarjeta,
          servicio_cupones_activos: servicio.servicio_cupones_activos,
          perfil_pago_transferencia: servicio.pago_transferencia,
          servicio_precio_gratuito: servicio.servicio_precio_gratuito,
          cobertura_domicilio: profesionalInfo.cobertura_domicilio,
        },
      });
    }
  };

  // Nueva función para manejar compras de contenido
  const handleComprarClick = (contenido) => {
    navigate(`/contenido/${contenido.contenido_link}`);
  };

  // Nueva función para manejar navegación a eventos
  const handleEventoClick = (evento) => {
    navigate(`/evento/${evento.evento_link}`);
  };

  // NUEVO: Variable derivada para controlar si se muestran evaluaciones
  const mostrarEvaluaciones = profesionalInfo?.perfil?.profesional_mostrar_evaluaciones === 1;

  const renderClinicaPillButton = () => {
    const handlePillClick = () => {
      window.location.href = "https://www.clinifica.com/pro";
    };

    return (
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          mt: 4,
          mb: 4,
        }}
      >
        <Typography
          sx={{
            fontFamily: "Quicksand-Regular",
            mb: 1.5,
            color: "#626262",
            fontSize: { md: "16px", xs: "14px" },
          }}
        >
          ¿Eres profesional de salud independiente?
        </Typography>

        <Box
          onClick={handlePillClick}
          sx={{
            display: "flex",
            alignItems: "center",
            bgcolor: "white",
            borderRadius: "50px",
            px: 3,
            py: 1,
            mb: 4,
            border: "1px solid #e0e0e0",
            boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
            "&:hover": {
              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.15)",
              cursor: "pointer",
            },
            transition: "box-shadow 0.3s ease",
          }}
        >
          {/* Placeholder for your icon */}
          <Box
            sx={{
              mr: 1.5,
              color: "#4285F4",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mb: 0,
            }}
          >
            <img
              src="/clinifica_logo.svg"
              alt="logo"
              style={{
                width: isMobile ? "27px" : "27px",
              }}
            />
          </Box>

          <Typography sx={{ fontFamily: "Quicksand-Regular", fontSize: { md: "16px", xs: "14px" }, mb: 0 }}>
            Crea tu perfil gratis en{" "}
            <Box
              component="span"
              sx={{ fontFamily: "Quicksand-Bold", color: "#4285F4" }}
            >
              Clinifica
            </Box>
          </Typography>
        </Box>
      </Box>
    );
  };

  // NUEVO: Función para renderizar secciones dinámicamente
  const renderSeccionesDinamicas = () => {
    // Extraer configuración de orden del backend
    const ordenSecciones = profesionalInfo?.perfil?.configuracion_perfil?.orden_secciones || ['agendas', 'contenido', 'eventos'];
    const ordenTiposAgenda = profesionalInfo?.perfil?.configuracion_perfil?.orden_tipos_agenda || ['online', 'presencial', 'domicilio'];

    // Mapeo de identificadores a componentes
    const seccionesMap = {
      'agendas': (
        <SeccionServicios
          key="agendas"
          ref={agendarSectionRef}
          serviceCardsRef={serviceCardsRef}
          profesionalInfo={profesionalInfo}
          expandedService={expandedService}
          setExpandedService={setExpandedService}
          handleAgendarClick={handleAgendarClick}
          isMobile={isMobile}
          ordenServicios={ordenTiposAgenda}
        />
      ),
      'contenido': (
        <SeccionContenido
          key="contenido"
          profesionalInfo={profesionalInfo}
          contentImageLoadingStates={contentImageLoadingStates}
          setContentImageLoadingStates={setContentImageLoadingStates}
          handleComprarClick={handleComprarClick}
          isMobile={isMobile}
        />
      ),
      'eventos': (
        <SeccionEventos
          key="eventos"
          profesionalInfo={profesionalInfo}
          isMobile={isMobile}
          handleEventoClick={handleEventoClick}
        />
      ),
    };

    // Renderizar secciones según orden
    const seccionesOrdenadas = ordenSecciones
      .filter(seccionId => seccionesMap[seccionId]) // Solo incluir secciones válidas
      .map(seccionId => seccionesMap[seccionId]);

    return seccionesOrdenadas; // Solo retorna las secciones dinámicas, sin evaluaciones
  };

  return (
    <>
      {/* SEO: Meta tags + JSON-LD structured data (maneja loading y datos cargados) */}
      <SEOProfesionalInjector profesionalInfo={profesionalInfo} />
      
      {/* LOGO */}
      <img
        src={logoImage}
        alt="Clinifica Logo"
        style={{
          width: isMobile ? "150px" : "200px",
          height: "auto",
          paddingTop: "15px",
          display: "block",
          marginLeft: "auto",
          marginRight: "auto",
          padding: 15,
        }}
      />
      
      {/* CONTENEDOR PRINCIPAL */}
      <Box
        sx={{
          maxWidth: isMobile ? "94%" : "800px",
          width: isMobile ? "94%" : "90%",
          mx: "auto",
          bgcolor: "#fbfafe",
          boxShadow: 1,
          marginTop: 0,
          marginBottom: 8,
          borderRadius: 2,
          p: isMobile ? 2 : 4,
        }}
      >
        {/* ============================== */}
        {/* SKELETON UNIFICADO DE LOADING   */}
        {/* ============================== */}
        {isLoading ? (
          <SkeletonPerfilCompleto isMobile={isMobile} />
        ) : (
          <>
            {/* 1. FOTO + INFORMACIÓN DEL PROFESIONAL */}
            <SeccionPerfil 
              profesionalInfo={profesionalInfo}
              isMobile={isMobile}
              shouldShowEvaluaciones={profesionalInfo?.perfil?.profesional_mostrar_evaluaciones === 1}
            />
            
            {/* 2. SOBRE MÍ */}
            <SeccionSobreMi 
              profesionalInfo={profesionalInfo}
            />
            
            {/* 3 ESPECIALIDADES */}
            <SeccionEspecialidades 
              profesionalInfo={profesionalInfo}
            />      
          
            {/* 4-6. SECCIONES DINÁMICAS (Servicios, Contenido, Eventos) */}
            {renderSeccionesDinamicas()}

            {/* 7. CONTACTO */}
            <SeccionContacto 
              profesionalInfo={profesionalInfo}
              isMobile={isMobile}
            />

            {/* 8. EVALUACIONES (después de contacto) */}
            {mostrarEvaluaciones && (
              <SeccionEvaluaciones
                profesionalInfo={profesionalInfo}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
              />
            )}
          </>
        )}
      </Box>
      
      {/* 9. BOTÓN CLINIFICA */}
      {renderClinicaPillButton()}
      
      {/* 10. BOTÓN FLOTANTE */}
      <FloatingAgendarButton
        targetRef={agendarSectionRef}
        isLoading={isLoading}
        serviceCardsRef={serviceCardsRef}
        profesionalInfo={profesionalInfo} // NUEVO: Pasar info del profesional para validar servicios
      />
    </>
  );
}

export default Profesionales;
